import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { FormGroupType } from '../../../../../../../../core/models/form-group-type';
import { ApplicationStateService } from '../../../../../../shared/services/application-state/application-state.service';
import { ScheduleDFormModel } from '../../../../models/schedule-d-form-model';
import { ScheduleDFormService } from '../../../../services/schedule-d-form/schedule-d-form.service';
import { ScheduleDBinaryLocationType } from '../../../../types/schedule-d-binary-location-type';
import { ScheduleDStepControlsMap } from '../../../../types/schedule-d-step-controls-map';
import { ScheduleDStepBaseService } from '../../../shared/services/schedule-d-step-base.service';

@Injectable({
    providedIn: 'root',
})
export class ScheduleDStepOneService extends ScheduleDStepBaseService<ScheduleDBinaryLocationType> {
    override stepControlMap: ScheduleDStepControlsMap<ScheduleDBinaryLocationType> =
        {
            fixed: [
                'locationName',
                'towerRegistrationNumber',
                'requireEWAToRegisterTower',
            ],
            'non-fixed': ['areaOfOperationCode'],
        };

    constructor() {
        super(inject(ScheduleDFormService), inject(ApplicationStateService));
    }

    override getLocationType(
        form: FormGroup<FormGroupType<ScheduleDFormModel>>,
    ): ScheduleDBinaryLocationType {
        return this.formService.getBinaryLocationType(form);
    }

    override isStepValid(
        form: FormGroup<FormGroupType<ScheduleDFormModel>>,
    ): Observable<boolean> {
        for (const control of this.formService.requiredControlsForAllTypes) {
            if (form.get(control)?.invalid) {
                return of(false);
            }
        }

        const type = this.getLocationType(form);

        for (const control of this.stepControlMap[type]) {
            const formControl = form.get(control);
            if (
                // When non-fixed, other fields must be valid.
                // When fixed, only check if fields are valid when the control is dirty.
                (type === 'non-fixed' || formControl?.dirty) &&
                formControl?.invalid
            ) {
                return of(false);
            }
        }

        return of(true);
    }
}
